module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_8_F_1.96246ce9.mp3";